import type { TOC } from '@ember/component/template-only';
import { eq } from 'ember-truth-helpers';
import MentionCard from './mention-card.gts';
import PlaceMap from './place-map.gts';
import { parseEnrichedData } from './item-card/utils.gts';
import { hasCoordinates } from '../utils/map';
import type { Mention } from '../schemas/mention.ts';

interface MentionsListSignature {
  Args: {
    mentions: Mention[];
    mentionId?: string;
    hideMap?: boolean;
  };
}

interface PlaceMarker {
  id: string;
  name: string;
  latitude: number;
  longitude: number;
  emoji?: string;
}

function extractMarkers(mentions: Mention[]): PlaceMarker[] {
  if (!mentions) return [];
  const markers: PlaceMarker[] = [];

  for (const mention of mentions) {
    const item = mention.item;
    if (item?.type === 'place') {
      const data = parseEnrichedData(item.enrichedData);

      if (data && 'location' in data) {
        const loc = data.location;
        if (hasCoordinates(loc)) {
          markers.push({
            id: String(item.id),
            name: String(item.name || 'Unknown Place'),
            latitude: loc.latitude,
            longitude: loc.longitude,
            emoji: item.emoji ?? undefined,
          });
        }
      }
    }
  }

  return markers;
}

const MentionsList: TOC<MentionsListSignature> = <template>
  {{#if @mentions.length}}
    {{#unless @hideMap}}
      {{#let (extractMarkers @mentions) as |markers|}}
        {{#if markers.length}}
          <div class="mb-6">
            <PlaceMap @markers={{markers}} />
          </div>
        {{/if}}
      {{/let}}
    {{/unless}}

    <div class="flex flex-col gap-4">
      {{#each @mentions as |mention|}}
        <MentionCard
          @mention={{mention}}
          @highlighted={{eq mention.id @mentionId}}
        />
      {{/each}}
    </div>
  {{else}}
    <div class="text-base-content/40 mt-8 text-center text-sm">
      No mentions extracted yet.
    </div>
  {{/if}}
</template>;

export default MentionsList;
